import * as React from "react";
import {
  sanitizeVendorPriceInput,
  VENDOR_PRICE_DECIMAL_PLACES,
  VENDOR_PRICE_MAX_INTEGER_DIGITS,
} from "views/vendors/constants/vendorItemPrice";

type Props = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
};

export default function VendorItemPriceInput({
  value,
  onChange,
  disabled = false,
  className,
  placeholder,
}: Props) {
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text");
    if (!pasted) return;

    const input = e.currentTarget;
    const start = input.selectionStart ?? value.length;
    const end = input.selectionEnd ?? value.length;
    const next = sanitizeVendorPriceInput(
      value.slice(0, start) + pasted + value.slice(end)
    );
    onChange(next);
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      value={value}
      onChange={(e) => onChange(sanitizeVendorPriceInput(e.target.value))}
      onPaste={handlePaste}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      maxLength={
        VENDOR_PRICE_MAX_INTEGER_DIGITS + 1 + VENDOR_PRICE_DECIMAL_PLACES
      }
      title={`Up to ${VENDOR_PRICE_MAX_INTEGER_DIGITS} digits and ${VENDOR_PRICE_DECIMAL_PLACES} decimal places`}
    />
  );
}
